export default __webpack_public_path__ + "static/media/13.a6edcd3f.jpg";